export const WORKFLOW_ID = 'FinancialAccountsWorkflow';
export const ANALYTICS_ID = 'financial_accounts_workflow';

export const BACKEND_KEY = 'Accounts';
export const NO_CONTRIBUTION = 0;
export const DOLLAR_CONTRIBUTION = 1;
export const PERCENTAGE_CONTRIBUTION = 2;
export const BASE_ACCOUNT = {
  AccountId: null,
  frontEndId: null,
  InterestRate: 0,
};

export const CONTRIBUTION_TYPE = {
  ANNUALLY: 1,
  MONTHLY: 0,
};

export const VIEWS = {
  TRANSACTIONS: 'TRANSACTIONS',
  NETWORTH: 'NETWORTH',
};
